// This file was auto-generated by Fern from our API Definition.
import * as FernIr from "../../../index.mjs";
export const ContainerType = {
    list: (value) => {
        return {
            list: value,
            type: "list",
            _visit: function (visitor) {
                return FernIr.ContainerType._visit(this, visitor);
            },
        };
    },
    map: (value) => {
        return Object.assign(Object.assign({}, value), { type: "map", _visit: function (visitor) {
                return FernIr.ContainerType._visit(this, visitor);
            } });
    },
    nullable: (value) => {
        return {
            nullable: value,
            type: "nullable",
            _visit: function (visitor) {
                return FernIr.ContainerType._visit(this, visitor);
            },
        };
    },
    optional: (value) => {
        return {
            optional: value,
            type: "optional",
            _visit: function (visitor) {
                return FernIr.ContainerType._visit(this, visitor);
            },
        };
    },
    set: (value) => {
        return {
            set: value,
            type: "set",
            _visit: function (visitor) {
                return FernIr.ContainerType._visit(this, visitor);
            },
        };
    },
    literal: (value) => {
        return {
            literal: value,
            type: "literal",
            _visit: function (visitor) {
                return FernIr.ContainerType._visit(this, visitor);
            },
        };
    },
    _visit: (value, visitor) => {
        switch (value.type) {
            case "list":
                return visitor.list(value.list);
            case "map":
                return visitor.map(value);
            case "nullable":
                return visitor.nullable(value.nullable);
            case "optional":
                return visitor.optional(value.optional);
            case "set":
                return visitor.set(value.set);
            case "literal":
                return visitor.literal(value.literal);
            default:
                return visitor._other(value);
        }
    },
};
